import React, { useState, useEffect } from 'react';
import { Menu, X, Dumbbell } from 'lucide-react';
import { clubData } from '../data/mock';

export const Header = ({ onJoin }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'Inici', href: '#' },
    { label: 'Equipament', href: '#equipment' },
    { label: 'Classes', href: '#classes' },
    { label: 'Reto 5', href: '#reto5' },
    { label: 'Preus', href: '#pricing' },
    { label: 'Contacte', href: '#contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg shadow-[#39FF14]/10' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3 group">
            <Dumbbell className="w-8 h-8 text-[#39FF14] group-hover:rotate-180 transition-transform duration-500" />
            <div className="hidden md:block">
              <div className="text-[#39FF14] font-black text-xl leading-tight">TRAINING</div>
              <div className="text-white text-xs">Club Esportiu Orpí</div>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-white hover:text-[#39FF14] transition-colors duration-300 font-medium"
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <button
            onClick={onJoin}
            data-testid="header-join-btn"
            className="hidden md:inline-block bg-[#39FF14] hover:bg-[#2EDD0F] text-black px-6 py-2 rounded-full font-bold transition-all duration-300 transform hover:scale-105"
          >
            Fes-te Soci
          </button>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white hover:text-[#39FF14] transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/98 backdrop-blur-md border-t border-[#39FF14]/20">
          <nav className="container mx-auto px-4 py-6 flex flex-col gap-4">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-white hover:text-[#39FF14] transition-colors duration-300 font-medium text-lg py-2"
              >
                {item.label}
              </a>
            ))}
            <button
              onClick={() => {
                setIsMobileMenuOpen(false);
                onJoin && onJoin();
              }}
              data-testid="header-join-btn-mobile"
              className="bg-[#39FF14] text-black px-6 py-3 rounded-full font-bold text-center mt-4"
            >
              Fes-te Soci
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};
